import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '@/lib/auth';

// Wrapper for protected routes. While auth is loading, render nothing
// (the dark page background means there is no flash). On unauthed,
// redirect to /login and remember where we were going.
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return <div className="min-h-screen bg-stone-950" />;
  }
  if (status === 'unauthed') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
